import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { api } from '@/redux/api';

type ConfirmAnnouncementModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onSend: () => void;
  unitIds?: number[];
  notificationText: string;
};

export default function ConfirmAnnouncementModal({
  isOpen,
  onCancel,
  onSend,
  unitIds = [],
  notificationText,
}: ConfirmAnnouncementModalProps) {
  const [sendAnnouncement] = api.useSendAnnouncementToUnitMutation();

  return (
    <Modal
      buttonItems={[
        <Button key="cancel" onClick={onCancel} variant="secondary">
          Cancel
        </Button>,
        <Button
          key="confirm"
          onClick={async () => {
            onSend();
            await sendAnnouncement({
              unitIds,
              notificationType: 'announcement',
              notificationText,
            });
          }}
          variant="primary"
        >
          Send Announcement
        </Button>,
      ]}
      open={isOpen}
      setOpen={onCancel}
      title="Confirm Announcement"
    >
      <div>
        <p>Are you sure you want to send the following announcement?</p>
        <div className="mt-4 rounded-md bg-gray-50 p-3">
          <p className="font-semibold">Message:</p>
          <p className="mt-1">{notificationText}</p>
        </div>
        <p className="mt-4">
          This announcement will be sent to{' '}
          <span className="font-semibold">{unitIds.length}</span> unit
          {unitIds.length ? 's' : ''}.
        </p>
      </div>
    </Modal>
  );
}
